import React from "react";
import { connect } from "react-redux";
import { goToNextPage } from "@ignitesales/neuro-application/src/actions/navigation-action-creators";
import { showValidationErrors } from '@ignitesales/neuro-application/src/actions/validation-action-creators';
import SurveyPageConnected from "./SurveyPageConnected";
import SurveyPageSkeleton from "../../../../../../theme/src/shared/js/components/pages/SurveyPageSkeleton";
import PageNavigation from "../PageNavigation";

const surveySkeleton = () => {
  return (
    <SurveyPageSkeleton>
      <PageNavigation
        className="skeleton"
        nextPageClicked={() => {}}
        previousPageClicked={() => {}}
      />
    </SurveyPageSkeleton>
  );
};

const SurveyPage = (props) => {
  let Component = SurveyPageConnected;
  if (props.incomplete) {
    Component = surveySkeleton;
  }

  return <Component {...props} />;
};

export default connect(
  (state, { location }) => {
    const {
      pages = [],
      progress: { total = 0 } = {},
      validationErrors = [],
      processingNavigation = false,
    } = state;

    const page = pages[location.pathname];
    const answers = state.answers || {};
    const props = {
      progress: total,
      validationErrors,
      processingNavigation,
    };

    if (!page) {
      props.incomplete = true;
    } else {
      props.currentPage = {
        path: page.path,
        page: page.page,
        questionGroups: page.questionGroups,
        answers: answers,
      };
    }

    return props;
  },
  (dispatch) => {
    return {
      nextPageClicked: () => {
        dispatch(goToNextPage(false));
      },
      onDisabledClick: () => {
        dispatch(showValidationErrors());
        },
      previousPageClicked: () => {
        dispatch(goToNextPage(true));
      },
    };
  }
)(SurveyPage);
